import { Link } from "react-router-dom";

function Scan(props) {
  return (
    <div className="App">
      <div className="davidDiv">
        <p dangerouslySetInnerHTML={{ __html: props.poemStep[0] }}></p>
        <img src={props.imageStep} className={props.imgClass}></img>
        <p dangerouslySetInnerHTML={{ __html: props.poemStep[1] }}></p>
      </div>

      <Link to="/">
        {" "}
        <button>Graft</button>
      </Link>
    </div>
  );
}

export default Scan;
